import React from "react";
import Form from "react-bootstrap/Form";
import { useTranslation } from "react-i18next";
import "./SetsRepsWeightInput.css";

// Per-set logging input: one row per set (reps + optional weight) with
// add/remove controls. Fully controlled.
export default function SetsRepsWeightInput({
  sets = [],
  onChange,
  repsPlaceholder,
  weightPlaceholder,
  showWeight = true,
}) {
  const { t } = useTranslation();

  const update = (index, field, value) =>
    onChange(sets.map((s, i) => (i === index ? { ...s, [field]: value } : s)));

  const addSet = () =>
    onChange([...sets, { reps: "", weight: "", _uid: Math.random().toString(36).slice(2) }]);

  const removeSet = (index) => onChange(sets.filter((_, i) => i !== index));

  const rowClass = `srw-row${showWeight ? "" : " srw-row--no-weight"}`;

  const placeholder = (value) =>
    value != null && String(value) !== "" && String(value) !== "0" ? String(value) : "";

  return (
    <div className="srw-input">
      <div className={`${rowClass} srw-header`}>
        <span className="srw-set-label">{t("feedback.set")}</span>
        <span>{t("feedback.reps")}</span>
        {showWeight && <span>{t("feedback.weight")}</span>}
        <span aria-hidden="true" />
      </div>

      {sets.map((set, index) => (
        <div className={rowClass} key={set._uid ?? index}>
          <span className="srw-set-label">{index + 1}</span>
          <Form.Control
            type="number"
            inputMode="numeric"
            min="0"
            size="sm"
            placeholder={placeholder(repsPlaceholder)}
            value={set.reps ?? ""}
            onChange={(e) => update(index, "reps", e.target.value)}
            aria-label={`${t("feedback.reps")} ${t("feedback.set")} ${index + 1}`}
          />
          {showWeight && (
            <Form.Control
              type="number"
              inputMode="decimal"
              min="0"
              step="0.5"
              size="sm"
              placeholder={placeholder(weightPlaceholder)}
              value={set.weight ?? ""}
              onChange={(e) => update(index, "weight", e.target.value)}
              aria-label={`${t("feedback.weight")} ${t("feedback.set")} ${index + 1}`}
            />
          )}
          <button
            type="button"
            className="srw-remove"
            onClick={() => removeSet(index)}
            disabled={sets.length <= 1}
            aria-label={t("feedback.remove_set")}
            title={t("feedback.remove_set")}
          >
            ×
          </button>
        </div>
      ))}

      <button
        type="button"
        className={`srw-add${showWeight ? "" : " srw-add--no-weight"}`}
        onClick={addSet}
      >
        <span className="srw-add-label">{t("feedback.add_set")}</span>
        <span className="srw-add-icon" aria-hidden="true">+</span>
      </button>
    </div>
  );
}
